import React from 'react';
import isEmptyish from '@tmap/mmm-core/isEmptyish';
// resolved via package.json export
// eslint-disable-next-line import/no-unresolved
import ReactPlayer from 'react-player/lazy';
import { Box } from '@tmap/mmm-style-guide/src/Box';
import { styled } from '@tmap/mmm-style-guide/src/styled';
import imageUrlBuilder from '@sanity/image-url';
import { PlayButton } from '@tmap/mmm-style-guide/src/Icon';
import PreloadablePicture from '../preloadablePicture';
import client from '../../client';

const PlayButtonIcon = styled(PlayButton)(({ theme }) => ({
  fontSize: '96px',
  position: 'absolute',
  [theme.breakpoints.down('md')]: {
    fontSize: '64px',
  },
}));

const builder = imageUrlBuilder(client);

const [PreviewPic, PreviewImg] = [PreloadablePicture, 'img'].map((component) => (
  styled(component)(() => ({
    width: '100%',
    minHeight: '100%',
    height: 'auto',
  }))
));

function Video(props) {
  const {
    url,
    previewImage,
    caption,
  } = props;
  if (isEmptyish(url)) return null;
  // https://github.com/CookPete/react-player#responsive-player
  // Currently using Canary version due to:
  // https://github.com/cookpete/react-player/issues/1428

  const previewPic = previewImage?.asset && (
    <PreviewPic preload>
      <source
        srcSet={builder.image(previewImage).format('webp').width(1440).height(810)
          .url()}
        width={1440}
        height={810}
        media='(min-width: 900px)'
      />
      <source
        srcSet={builder.image(previewImage).format('webp').width(900).height(506)
          .url()}
        width={900}
        height={506}
        media='(min-width: 600px) and (max-width: 899px)'
      />
      <source
        srcSet={builder.image(previewImage).format('webp').width(600).height(337)
          .url()}
        width={600}
        height={337}
        media='(max-width: 599px)'
      />
      <PreviewImg
        src={builder.image(previewImage).width(1440).height(810).url()}
        width={1440}
        height={810}
        alt={caption || ''}
      />
    </PreviewPic>
  );

  return (
    <Box
      sx={{
        position: 'relative',
        paddingTop: '56.25%',
      }}
    >
      <ReactPlayer
        url={url}
        controls
        light={previewPic || true}
        playing
        width='100%'
        height='100%'
        playIcon={<PlayButtonIcon />}
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
        }}
      />
    </Box>
  );
}

export default Video;
